import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import state from './state'
import mutations from './mutations'
import createLogger from 'vuex/dist/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
// const storagePlugin = store => {
//   store.subscribe((mutation, state) => {
//     if (mutation.type === 'SET_MSG_LIST' || mutation.type === 'SET_NULL_MSG' || mutation.type === 'ADD_MSG') {
//       cache.saveMsgList(state.msgList)
//     }
//   })
// }

export default new Vuex.Store({
  actions,
  getters,
  state,
  mutations,
  strict: debug,
  plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js